export const PAGE_CONFIG = {
  name: 'CommonPermissionWrap',
  children: [
    {
      name: 'InfluencerWrapper',
      config: {
        queryKey: 'tab',
        defaultTab: 'brandOverview',
        titleEn: '',
        titleCn: '',
        tabs: [
          {
            key: 'brandOverview',
            nameEn: 'Brand Overview',
            nameCn: '品牌网红概览',
            name: 'InfluencerBrandOverview',
            prNoticeMarquee: {
              textEn: '',
              textZh: '',
            },
            info: {
              show: true,
              labelCn: '数据更新',
              labelEn: 'Data Update',
              tipsZh: [
                '更新频率：本页面的KOL数据（除缺少粉丝量数据的KOL外）每日更新一次。',
                '粉丝量更新：每日仅更新粉丝量大于5K或者当天有发帖的网红的粉丝量。',
                '每日观看、点赞、评论计算逻辑：按日汇总当天发的帖子数，统计这些帖子的数据（如观看、点赞、评论、互动）作为发帖日的观看、点赞、评论、互动。',
              ],
              tipsEn: [
                'Update Frequency: Influencers data on this page is updated daily, excluding those Influencers that do not have followers data.',
                'Followers Update: Only update the followers of opinion leaders with more than 5K followers or who post on that day.',
                'Calculation logic of daily views, likes and comments: Summarize posts on a daily basis, and count the data of these posts (such as views, likes and comments and engagement) as the views, likes, comments and engagement on the Posting day.',
              ],
            },
            componentProps: {
              hidePageHeader: true,
              hideTips: true,
              enableSourcePageLog: false,
            },
            logConfig: {
              enabled: true,
              pageId: '910001',
              pageName: 'influencer-brandOverview',
              extInfo: 'home-studio-influencer-brandOverview',
              pagePath: '/influencer?tab=brandOverview',
            },
          },
          {
            key: 'brandCreatorList',
            nameEn: 'Brand Creator List',
            nameCn: '品牌网红列表',
            name: 'InfluencerBrandCreatorList',
            prNoticeMarquee: {
              textEn: '',
              textZh: '',
            },
            info: {
              show: true,
              labelCn: '数据更新',
              labelEn: 'Data Update',
              tipsZh: [
                '更新频率：本页面的KOL数据（除缺少粉丝量数据的KOL外）每日更新一次。',
                '粉丝量更新：每日仅更新粉丝量大于5K或者当天有发帖的网红的粉丝量。',
                '每日观看、点赞、评论计算逻辑：按日汇总当天发的帖子数，统计这些帖子的数据（如观看、点赞、评论、互动）作为发帖日的观看、点赞、评论、互动。',
              ],
              tipsEn: [
                'Update Frequency: Influencers data on this page is updated daily, excluding those Influencers that do not have followers data.',
                'Followers Update: Only update the followers of opinion leaders with more than 5K followers or who post on that day.',
                'Calculation logic of daily views, likes and comments: Summarize posts on a daily basis, and count the data of these posts (such as views, likes and comments and engagement) as the views, likes, comments and engagement on the Posting day.',
              ],
            },
            componentProps: {
              hidePageHeader: true,
              hideTips: true,
              defaultMediaType: 'sum',
              enableSourcePageLog: false,
            },
            logConfig: {
              enabled: true,
              pageId: '910002',
              pageName: 'influencer-brandCreatorList',
              extInfo: 'home-studio-influencer-brandCreatorList',
              pagePath: '/influencer?tab=brandCreatorList',
            },
          },
        ],
      },
    },
  ],
};
